interface Props {
    onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
    text?: string;
}

export function CancelButton({ onClick, text }: Props) {
    return (

        <button 
            type="button"
            onClick={onClick}
            className="border-2 border-gray-300 rounded-[3px] px-[6px] py-[2px] flex gap-1 items-center hover:bg-gray-100">
            <p className="text-gray-600 text-[13px] font-semibold text-center">{text ?? "Cancelar"}</p>
        </button>
    );
}